export default "__VITE_ASSET__DDo62oBG__"